"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInDevelopmentCap = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgInDevelopmentCap = function SvgInDevelopmentCap(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "100%",
    height: "100%",
    viewBox: "0 0 692 522",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.175 142.649c-97.48 35.874-51.945 188.003-21.977 249.088 180.664 85.309 556.148 215.229 612.774 52.439 70.781-203.488 55.369-357.671-70.782-423.505-126.15-65.834-216.91 42.75-301.962 86.924-85.052 44.174-101.89-7.695-218.053 35.054z",
    fill: "url(#svg-in-development-cap__paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M166.204 374.922c-18.495 12.768-21.216 40.47-20.264 52.724-5.708-3.42-6.565-5.7-11.702-17.669-5.137-11.97-6.849-19.38-23.688-18.81-16.84.57-22.548 23.94-5.709 13.68 16.839-10.26 17.41 3.135 22.548 17.099 4.11 11.172 15.412 16.435 20.549 17.67 9.989.19 32.08.456 40.528 0 13.128-16.245 1.427-45.029-1.142-59.849 1.712-1.425 5.137-3.99 5.709-11.685.591-7.961-4.853-11.97-7.707-12.54l-8.276-12.255c-1.332 2.375-4.224 7.752-5.138 10.26-2.74-.456-5.708 3.42-6.849 5.415l-9.99-3.99c2.379 4.655 7.934 15.162 11.131 19.95z",
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 44.621,
    y: 234.418,
    width: 101.035,
    height: 116.279,
    rx: 13.554,
    fill: "#E2E9F9"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    opacity: 0.7,
    cx: 70.307,
    cy: 262.918,
    rx: 15.412,
    ry: 15.39,
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M70.307 253.798c-5.708.228-5.043 5.415-3.996 7.98-1.713 2.09-4.624 6.555-2.569 7.695 2.569 1.425 4.281-1.425 6.565-1.425 2.283 0 5.422 2.565 7.135 1.425 1.712-1.14-1.713-7.125-2.569-7.695.856-2.755 1.142-8.208-4.566-7.98z",
    fill: "#E2E9F9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.5,
    x: 93.141,
    y: 250.948,
    width: 46.807,
    height: 17.1,
    rx: 8.55,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.5,
    x: 93.141,
    y: 274.318,
    width: 46.807,
    height: 3.99,
    rx: 1.995,
    fill: "#F2F7F9"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    opacity: 0.7,
    cx: 70.307,
    cy: 306.807,
    rx: 15.412,
    ry: 15.39,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M70.307 297.687c-5.708.228-5.042 5.415-3.996 7.98-1.712 2.09-4.624 6.555-2.569 7.695 2.569 1.425 4.281-1.425 6.565-1.425 2.284 0 5.422 2.565 7.135 1.425 1.712-1.14-1.713-7.125-2.569-7.695.856-2.755 1.142-8.208-4.566-7.98z",
    fill: "#E2E9F9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 93.141,
    y: 294.837,
    width: 46.807,
    height: 17.1,
    rx: 8.55,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 93.141,
    y: 318.207,
    width: 46.807,
    height: 3.99,
    rx: 1.995,
    fill: "#F2F7F9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.9,
    x: 150.221,
    y: 79.38,
    width: 116.447,
    height: 219.448,
    rx: 7.393,
    fill: "#E2E9F9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M162.861 103.545c-.625-.176-1.097-.467-1.414-.872-.315-.402-.472-.934-.472-1.597v-1.053c0-.856-.374-1.284-1.122-1.284v-.767c.748 0 1.122-.427 1.122-1.28v-1.1c.007-.645.165-1.165.472-1.56.31-.398.782-.687 1.414-.867l.201.608c-.738.236-1.107.851-1.107 1.846v1.068c0 .8-.295 1.357-.884 1.67.589.318.884.88.884 1.688v1.089c.011.969.38 1.571 1.107 1.803l-.201.608zM251.456 103.545c.625-.176 1.096-.467 1.414-.872.314-.402.471-.935.471-1.597v-1.053c0-.856.374-1.285 1.123-1.285v-.766c-.749 0-1.123-.427-1.123-1.28v-1.1c-.007-.645-.164-1.165-.471-1.56-.311-.398-.782-.687-1.414-.867l-.201.608c.737.236 1.106.851 1.106 1.845v1.069c0 .8.295 1.357.885 1.67-.59.318-.885.88-.885 1.688v1.089c-.01.969-.379 1.57-1.106 1.803l.201.608zM162.861 177.54c-.625-.177-1.096-.468-1.414-.873-.314-.402-.471-.934-.471-1.597v-1.052c0-.857-.374-1.285-1.123-1.285v-.767c.749 0 1.123-.427 1.123-1.28v-1.1c.007-.645.164-1.165.471-1.56.311-.398.782-.687 1.414-.867l.201.608c-.738.237-1.106.852-1.106 1.846v1.068c0 .8-.295 1.357-.885 1.671.59.317.885.88.885 1.687v1.089c.01.97.379 1.571 1.106 1.803l-.201.609zM251.456 177.54c.625-.177 1.096-.468 1.414-.873.314-.402.471-.934.471-1.597v-1.052c0-.857.374-1.285 1.123-1.285v-.767c-.749 0-1.123-.427-1.123-1.28v-1.1c-.007-.645-.164-1.165-.471-1.56-.311-.398-.782-.687-1.414-.867l-.201.608c.737.237 1.106.852 1.106 1.846v1.068c0 .8.295 1.357.885 1.671-.59.317-.885.88-.885 1.687v1.089c-.01.97-.379 1.571-1.106 1.803l.201.609zM162.861 192.359c-.625-.176-1.096-.467-1.414-.872-.314-.402-.471-.934-.471-1.597v-1.053c0-.856-.374-1.285-1.123-1.285v-.766c.749 0 1.123-.427 1.123-1.28v-1.1c.007-.645.164-1.165.471-1.56.311-.398.782-.687 1.414-.867l.201.608c-.738.236-1.106.851-1.106 1.846v1.068c0 .8-.295 1.357-.885 1.671.59.317.885.879.885 1.687v1.089c.01.969.379 1.57 1.106 1.803l-.201.608zM251.456 192.359c.625-.176 1.096-.467 1.414-.872.314-.402.471-.934.471-1.597v-1.053c0-.856.374-1.285 1.123-1.285v-.766c-.749 0-1.123-.427-1.123-1.28v-1.1c-.007-.645-.164-1.165-.471-1.56-.311-.398-.782-.687-1.414-.867l-.201.608c.737.236 1.106.851 1.106 1.846v1.068c0 .8.295 1.357.885 1.671-.59.317-.885.879-.885 1.687v1.089c-.01.969-.379 1.57-1.106 1.803l.201.608zM162.861 287.548c-.625-.176-1.096-.467-1.414-.872-.314-.402-.471-.935-.471-1.597v-1.053c0-.856-.374-1.285-1.123-1.285v-.766c.749 0 1.123-.427 1.123-1.28v-1.1c.007-.645.164-1.165.471-1.56.311-.398.782-.688 1.414-.867l.201.608c-.738.236-1.106.851-1.106 1.845v1.069c0 .8-.295 1.357-.885 1.671.59.317.885.879.885 1.686v1.09c.01.969.379 1.57 1.106 1.803l-.201.608zM251.456 287.548c.625-.176 1.096-.467 1.414-.872.314-.402.471-.935.471-1.597v-1.053c0-.856.374-1.285 1.123-1.285v-.766c-.749 0-1.123-.427-1.123-1.28v-1.1c-.007-.645-.164-1.165-.471-1.56-.311-.398-.782-.688-1.414-.867l-.201.608c.737.236 1.106.851 1.106 1.845v1.069c0 .8.295 1.357.885 1.671-.59.317-.885.879-.885 1.686v1.09c-.01.969-.379 1.57-1.106 1.803l.201.608z",
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.543 98.475a.855.855 0 01-.856.855h-2.874a.856.856 0 110-1.71h2.874c.473 0 .856.382.856.855zm-8.623 0a.856.856 0 01-.856.855h-5.749a.856.856 0 110-1.71h5.749c.472 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.856.856 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-2.874a.856.856 0 110-1.71h2.874c.473 0 .856.382.856.855z",
    fill: "url(#svg-in-development-cap__paint1_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.543 172.469a.855.855 0 01-.856.855h-2.874a.856.856 0 01-.857-.855c0-.472.384-.855.857-.855h2.874c.473 0 .856.383.856.855zm-8.623 0a.856.856 0 01-.856.855h-5.749a.856.856 0 01-.857-.855c0-.472.384-.855.857-.855h5.749c.472 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.856.856 0 01-.857-.855c0-.472.384-.855.857-.855h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-2.874a.856.856 0 01-.857-.855c0-.472.384-.855.857-.855h2.874c.473 0 .856.383.856.855z",
    fill: "url(#svg-in-development-cap__paint2_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.543 187.289a.855.855 0 01-.856.855h-2.874a.856.856 0 110-1.71h2.874c.473 0 .856.382.856.855zm-8.623 0a.856.856 0 01-.856.855h-5.749a.856.856 0 110-1.71h5.749c.472 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.856.856 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.382.856.855zm-11.498 0a.855.855 0 01-.856.855h-2.874a.856.856 0 110-1.71h2.874c.473 0 .856.382.856.855z",
    fill: "url(#svg-in-development-cap__paint3_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.543 282.477a.855.855 0 01-.856.855h-2.874a.856.856 0 110-1.71h2.874c.473 0 .856.383.856.855zm-8.623 0a.855.855 0 01-.856.855h-5.749a.856.856 0 110-1.71h5.749c.472 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.856.856 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-5.749a.855.855 0 110-1.71h5.749c.473 0 .856.383.856.855zm-11.498 0a.855.855 0 01-.856.855h-2.874a.856.856 0 110-1.71h2.874c.473 0 .856.383.856.855z",
    fill: "url(#svg-in-development-cap__paint4_linear)"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 107.31,
    width: 86.764,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 115.29,
    width: 25.687,
    height: 3.99,
    rx: 1.995,
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 121.56,
    width: 35.391,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 127.83,
    width: 53.657,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 135.81,
    width: 75.348,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 143.79,
    width: 27.97,
    height: 3.99,
    rx: 1.995,
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 150.059,
    width: 27.97,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 158.04,
    width: 86.764,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 236.129,
    width: 91.902,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 244.108,
    width: 33.107,
    height: 3.99,
    rx: 1.995,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 251.518,
    width: 33.107,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 266.338,
    width: 15.983,
    height: 3.99,
    rx: 1.995,
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 162.209,
    y: 258.358,
    width: 86.194,
    height: 3.99,
    rx: 1.995,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 165.635,
    y: 196.229,
    width: 86.764,
    height: 16.53,
    rx: 6.161,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 165.635,
    y: 215.609,
    width: 24.545,
    height: 16.53,
    rx: 6.161,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 195.887,
    y: 215.609,
    width: 24.545,
    height: 16.53,
    rx: 6.161,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 434.489,
    y: 244.678,
    width: 152.408,
    height: 137.369,
    rx: 13.554,
    fill: "#E2E9F9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.762,
    y: 263.489,
    width: 106.172,
    height: 22.23,
    rx: 4.929,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.761,
    y: 329.038,
    width: 106.172,
    height: 22.23,
    rx: 4.929,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.761,
    y: 289.708,
    width: 95.326,
    height: 13.68,
    rx: 4.929,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.761,
    y: 306.808,
    width: 58.223,
    height: 3.99,
    rx: 1.995,
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.761,
    y: 314.788,
    width: 58.223,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.761,
    y: 355.258,
    width: 58.223,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 444.761,
    y: 363.238,
    width: 58.223,
    height: 3.99,
    rx: 1.995,
    fill: "#F9FCFE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.1,
    x: 359.713,
    y: 79.38,
    width: 170.674,
    height: 170.998,
    rx: 18.483,
    fill: "#CD67DF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.8,
    x: 377.977,
    y: 98.76,
    width: 98.751,
    height: 58.709,
    rx: 3.697,
    fill: "#C446D9"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.6,
    x: 385.971,
    y: 135.24,
    width: 7.421,
    height: 17.1,
    rx: 2.464,
    fill: "#FAF2FF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.9,
    x: 400.812,
    y: 123.27,
    width: 7.421,
    height: 28.5,
    rx: 2.464,
    fill: "#FAF2FF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.6,
    x: 415.654,
    y: 127.83,
    width: 7.421,
    height: 23.94,
    rx: 2.464,
    fill: "#FAF2FF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.6,
    x: 430.495,
    y: 119.28,
    width: 7.421,
    height: 32.49,
    rx: 2.464,
    fill: "#FAF2FF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.3,
    x: 445.336,
    y: 127.83,
    width: 7.421,
    height: 23.94,
    rx: 2.464,
    fill: "#FAF2FF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.8,
    x: 460.178,
    y: 124.41,
    width: 7.421,
    height: 27.36,
    rx: 2.464,
    fill: "#FAF2FF"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    opacity: 0.6,
    x: 489.286,
    y: 99.33,
    width: 31.966,
    height: 133.949,
    rx: 6.161,
    fill: "#CD68DE"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 104.461,
    width: 24.545,
    height: 5.7,
    rx: 2.85,
    fill: "#E8C7ED"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 124.98,
    width: 24.545,
    height: 5.7,
    rx: 2.85,
    fill: "#E8C7ED"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 162.6,
    width: 24.545,
    height: 13.11,
    rx: 3.697,
    fill: "#E8C7ED"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 134.1,
    width: 16.554,
    height: 3.42,
    rx: 1.71,
    fill: "#F7EAED"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 139.23,
    width: 23.974,
    height: 3.42,
    rx: 1.71,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 113.58,
    width: 16.554,
    height: 2.28,
    rx: 1.14,
    fill: "#E8C7ED"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 117,
    width: 23.974,
    height: 2.28,
    rx: 1.14,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 146.07,
    width: 16.554,
    height: 2.28,
    rx: 1.14,
    fill: "#F7EAED"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 149.49,
    width: 23.974,
    height: 2.28,
    rx: 1.14,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 179.699,
    width: 16.554,
    height: 2.28,
    rx: 1.14,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 492.713,
    y: 183.12,
    width: 23.974,
    height: 2.28,
    rx: 1.14,
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.271 213.614a3.708 3.708 0 00-3.71 3.705 3.708 3.708 0 003.71 3.705 3.708 3.708 0 003.711-3.705 3.708 3.708 0 00-3.711-3.705zm-9.989 3.705c0-5.509 4.472-9.975 9.989-9.975s9.99 4.466 9.99 9.975c0 5.509-4.473 9.975-9.99 9.975s-9.989-4.466-9.989-9.975z",
    fill: "#E8C7ED"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.072 174.284c-10.876 0-19.693 8.805-19.693 19.665 0 10.861 8.817 19.665 19.693 19.665 10.876 0 19.693-8.804 19.693-19.665 0-10.86-8.817-19.665-19.693-19.665zm-27.114 19.665c0-14.953 12.14-27.075 27.114-27.075 14.975 0 27.114 12.122 27.114 27.075s-12.139 27.075-27.114 27.075c-14.974 0-27.114-12.122-27.114-27.075z",
    fill: "#CD68DE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.072 174.284c-10.876 0-19.693 8.805-19.693 19.665 0 10.861 8.817 19.665 19.693 19.665 10.876 0 19.693-8.804 19.693-19.665a3.708 3.708 0 013.711-3.705 3.708 3.708 0 013.71 3.705c0 14.953-12.139 27.075-27.114 27.075-14.974 0-27.114-12.122-27.114-27.075s12.14-27.075 27.114-27.075a3.708 3.708 0 013.71 3.705 3.707 3.707 0 01-3.71 3.705z",
    fill: "#B943CD"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M334.025 302.818c-28.084-3.648-45.19 15.39-50.232 25.365 26.448 2.185 87.221 6.612 118.73 6.84-13.243-28.728-40.147-32.87-51.944-31.35l-3.71 1.995c-1.142.19-5.309-.114-12.844-2.85z",
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M324.606 299.968c3.139 5.985 12.843 21.945 16.554 21.375 2.568 0 14.556-14.25 16.268-16.815 1.37-2.052.761-2.945.285-3.135-5.993-1.33-21.006-3.477-33.107-1.425z",
    fill: "#CACFD5"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "svg-in-development-cap__a",
    maskUnits: "userSpaceOnUse",
    x: 305,
    y: 246,
    width: 75,
    height: 68
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M357.999 302.533l-1.712 1.995c-5.423 5.985-12.444 8.55-14.27 8.55-11.988 0-34.535-32.775-36.533-39.045-1.598-5.016 1.237-6.08 2.854-5.985l6.85-12.54 12.558-8.55c4.281 0 20.607 1.14 51.659 5.7-1.826 20.064-14.841 41.325-21.406 49.875z",
    fill: "#6FA8F5"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#svg-in-development-cap__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M358 303.673l-1.712 1.995c-5.423 5.985-12.444 8.55-14.271 8.55-11.987 0-34.534-32.775-36.532-39.045-1.598-5.016 1.237-6.08 2.854-5.985l6.85-12.54 12.558-8.55c4.281 0 20.607 1.14 51.659 5.7-1.827 20.064-14.841 41.325-21.406 49.875z",
    fill: "#E2E9F9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M324.609 298.828c9.418 1.995 13.414-8.835 13.414-12.54 0-8.265-20.55-7.98-23.974-3.135-3.425 4.845 1.141 13.68 10.56 15.675zM357.706 299.1c9.419 1.995 13.415-8.835 13.415-12.54 0-8.265-20.55-7.98-23.975-3.135-3.425 4.845 1.142 13.68 10.56 15.675z",
    fill: "#CACFD5"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: 315.76,
    y: 279.448,
    width: 53.086,
    height: 3.42,
    rx: 1.71,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M318.898 259.498c-.914 6.384-3.615 15.77-4.852 19.665-24.26-34.485 2.854-45.029 7.42-43.319 2.569-15.96 35.677-20.805 52.516-4.275 21.976 21.573-3.14 39.614-6.565 40.469-2.568-4.465-9.875-13.224-18.551-12.54-10.846.855-16.839-1.14-21.121-6.84-3.139 10.545-5.708 9.12-8.847 6.84z",
    fill: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#ECF4F6",
    d: "M263.813 429.356H415.65v10.26H263.813z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M263.813 337.277c0-6.124 4.965-11.089 11.09-11.089h129.658c6.125 0 11.09 4.965 11.09 11.089v92.079H263.813v-92.079z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M263.813 337.277c0-6.124 4.965-11.089 11.09-11.089h135.903a4.845 4.845 0 014.845 4.845l-95.041 60.704-56.797 37.619v-92.079z",
    fill: "url(#svg-in-development-cap__paint5_linear)"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: 339.448,
    cy: 364.662,
    rx: 11.131,
    ry: 11.115,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "svg-in-development-cap__b",
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 395,
    width: 33,
    height: 45
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M208.73 439.794h25.972l2.854-44.175-32.251.57 3.425 43.605z",
    fill: "#00CDFF"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#svg-in-development-cap__b)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M208.73 439.794h25.972l2.854-44.175-32.251.57 3.425 43.605z",
    fill: "#CACFD5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2E9F9",
    d: "M205.59 414.429h31.966v9.69H205.59z"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: 221.573,
    cy: 419.559,
    rx: 3.996,
    ry: 3.99,
    fill: "#B943CD"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: 221.571,
    cy: 419.559,
    rx: 2.283,
    ry: 2.28,
    fill: "#CACFD5"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M204.45 379.944c-3.654 14.592 1.522 17.1 4.566 16.53 6.66.57 21.691 1.197 28.541-.855-6.564-25.364-22.833-41.609-24.545-41.609-1.713 0-3.996 7.695-8.562 25.934z",
    fill: "url(#svg-in-development-cap__paint6_linear)"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: 221.288,
    cy: 395.904,
    rx: 16.268,
    ry: 4.275,
    fill: "#B943CD"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 4.092,
    y: 439.616,
    width: 667.857,
    height: 10.83,
    rx: 5.415,
    fill: "url(#svg-in-development-cap__paint7_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: 0.5,
    d: "M606.304 325.903c21.691 3.419 33.203 21.754 36.247 30.494-2.664 10.355-8.277 33.06-9.418 41.04-16.668-11.628-25.973-32.965-28.541-42.18l6.849-3.99c-.38-.76-2.169-2.451-6.279-3.135 1.998-8.265 0-11.97 1.142-22.229z",
    fill: "#CBE781"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.688 308.541c2.521.369 5.014 1.995 6.939 5.396 1.889 3.338 2.816 6.347 2.932 9.356.115 3.005-.58 5.963-1.864 9.196-1.282 3.226-3.163 6.756-5.44 10.898-.363.661-.736 1.337-1.119 2.03-2.023 3.667-4.314 7.818-6.77 12.662-9.246 18.24-2.699 32.1 1.619 36.687a.57.57 0 11-.832.781c-4.625-4.913-11.282-19.287-1.805-37.983 2.465-4.863 4.767-9.034 6.79-12.7.382-.693.755-1.367 1.116-2.025 2.281-4.149 4.128-7.62 5.38-10.77 1.249-3.144 1.891-5.939 1.784-8.732-.107-2.789-.965-5.623-2.785-8.839-1.786-3.155-4.002-4.521-6.11-4.829-2.13-.311-4.249.441-5.844 1.716-1.607 1.283-2.595 3.022-2.591 4.594a3.43 3.43 0 00.786 2.197c.549.677 1.428 1.302 2.747 1.775 2.718.974 4.395.829 5.356.289.935-.526 1.352-1.52 1.336-2.666-.016-1.155-.479-2.355-1.168-3.117-.341-.377-.717-.626-1.097-.73-.368-.102-.777-.079-1.225.145-2.215 1.106-2.669 2.16-2.646 2.782.024.664.586 1.181 1.075 1.279l.16.032c.316.064.621.126.921.158.351.037.629.023.834-.048a.672.672 0 00.422-.398c.114-.256.189-.69.122-1.412-.062-.678-.276-.828-.356-.864-.118-.053-.356-.052-.705.127-.332.17-.647.445-.84.708a.985.985 0 00-.158.293.571.571 0 01-.987.569c-.193-.289-.181-.611-.118-.855.064-.245.194-.478.343-.681a3.662 3.662 0 011.238-1.048c.471-.241 1.108-.416 1.694-.153.624.28.946.935 1.026 1.799.076.818.009 1.474-.216 1.98-.237.532-.63.854-1.094 1.013-.437.151-.909.147-1.325.103-.358-.037-.724-.112-1.036-.175l-.149-.03c-.937-.187-1.945-1.095-1.992-2.355-.048-1.302.924-2.669 3.276-3.844.693-.346 1.391-.403 2.04-.224.638.176 1.192.569 1.64 1.065.89.983 1.443 2.455 1.463 3.865.02 1.418-.508 2.883-1.919 3.675-1.384.778-3.454.811-6.301-.209-1.464-.525-2.538-1.254-3.248-2.131a4.568 4.568 0 01-1.041-2.911c-.005-2.026 1.237-4.063 3.019-5.487 1.794-1.433 4.223-2.319 6.723-1.954zm-3.041 8.015v-.001.001z",
    fill: "#CD67DF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M629.707 394.015c-3.52-22.135.742-69.939 45.951-84.075 1.827 8.664 3.425 20.14 3.995 24.795l-7.42 5.415 7.42 1.995-1.997 10.83-5.423 1.425 2.568 5.985c-10.25 10.469-27.195 29.331-27.611 35.412 5.127.721 7.634 1.456 2.495 1.923-1.845.167-2.589-.554-2.495-1.923-4.897-.689-12.185-1.365-17.483-1.782z",
    fill: "#CBE781"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.091 331.531a77.469 77.469 0 015.072-.47c1.001-.055 1.955-.077 2.734-.042.389.018.74.051 1.035.102.288.05.548.123.737.236l-.294.489c-.097-.058-.273-.116-.542-.163a7.764 7.764 0 00-.963-.094c-.751-.035-1.683-.014-2.675.041a77.36 77.36 0 00-5.459.521 198.926 198.926 0 00-7.924 15.521c2.003-.573 5.862-1.301 9.2-.676l-.105.561c-3.504-.656-7.655.24-9.41.806a230.53 230.53 0 00-7.468 18.603c.881-.389 2.09-.837 3.399-1.163 1.646-.41 3.484-.636 5.033-.279l-.128.555c-1.419-.327-3.153-.126-4.767.277a20.515 20.515 0 00-3.8 1.359c-2.466 7.079-4.312 13.473-5.57 18.612.99-.517 2.363-1.084 3.809-1.396 1.746-.376 3.661-.393 5.128.583l-.317.474c-1.273-.848-2.998-.865-4.69-.5-1.623.35-3.158 1.039-4.111 1.588a119.13 119.13 0 00-1.035 4.715l-.56-.11c.281-1.427.632-3.035 1.055-4.799a17.932 17.932 0 00-1.263-4.077c-.687-1.507-1.613-2.824-2.77-3.349l.236-.519c1.355.615 2.354 2.099 3.053 3.632.472 1.034.82 2.12 1.053 3.045 1.259-5.058 3.064-11.261 5.448-18.099-.594-1.553-2.254-4.952-4.44-6.917l.382-.424c2.026 1.821 3.59 4.775 4.342 6.528a231.557 231.557 0 017.469-18.591 49.971 49.971 0 00-1.515-4.317c-.317-.772-.645-1.487-.961-2.047a5.736 5.736 0 00-.455-.702c-.146-.188-.271-.305-.37-.364l.294-.489c.186.112.362.292.527.503.167.214.335.477.501.772.333.59.671 1.329.992 2.11a49.502 49.502 0 011.343 3.752 198.99 198.99 0 017.917-15.491 22.11 22.11 0 00-.918-3.158c-.479-1.281-1.111-2.572-1.876-3.446l.429-.375c.833.951 1.494 2.319 1.982 3.622.357.953.626 1.886.803 2.622 4.299-7.467 9.21-14.746 14.763-21.344l.437.366c-5.563 6.61-10.483 13.911-14.787 21.406z",
    fill: "#74BA00"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "svg-in-development-cap__c",
    maskUnits: "userSpaceOnUse",
    x: 614,
    y: 391,
    width: 48,
    height: 49
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M614.866 391.736h46.807v24.476c0 12.926-10.478 23.404-23.404 23.404-12.925 0-23.403-10.478-23.403-23.404v-24.476z",
    fill: "#043274"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#svg-in-development-cap__c)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M614.866 391.736h46.807v24.476c0 12.926-10.478 23.404-23.404 23.404-12.925 0-23.403-10.478-23.403-23.404v-24.476z",
    fill: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M623.429 383.187h46.807v24.476c0 12.925-10.478 23.403-23.404 23.403-12.925 0-23.403-10.478-23.403-23.403v-24.476z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M635.417 370.646h46.807v24.476c0 12.926-10.478 23.404-23.404 23.404-12.925 0-23.403-10.478-23.403-23.404v-24.476z",
    fill: "#F9FCFE"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint0_linear",
    x1: 346.137,
    y1: -25.093,
    x2: 359.533,
    y2: 369.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#F2F7F9"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 0.776,
    stopColor: "#F9FCFE"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint1_linear",
    x1: 248.972,
    y1: 98.189,
    x2: 168.772,
    y2: 98.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint2_linear",
    x1: 248.972,
    y1: 172.184,
    x2: 168.772,
    y2: 172.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint3_linear",
    x1: 248.972,
    y1: 187.004,
    x2: 168.772,
    y2: 187.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint4_linear",
    x1: 248.972,
    y1: 282.192,
    x2: 168.772,
    y2: 282.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint5_linear",
    x1: 339.732,
    y1: 326.188,
    x2: 339.732,
    y2: 429.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#ECF4F6"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#ECF4F6"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint6_linear",
    x1: 220.596,
    y1: 395.627,
    x2: 214.359,
    y2: 356.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#E8C4F2"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 0.922,
    stopColor: "#fff"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "svg-in-development-cap__paint7_linear",
    x1: 25.798,
    y1: 444.893,
    x2: 630.574,
    y2: 444.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#F2F7F9"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#ECF4F6"
  }))));
};

exports.SvgInDevelopmentCap = SvgInDevelopmentCap;